export default "__VITE_ASSET__xdUJBpUU__"